import {
    DELETE_IMAGE_REQUEST,
    deleteImageSuccess,
    deleteImageFailure,
    showSuccessNotification
} from 'Redux/Action';
import { ofType } from 'redux-observable';
import { from } from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';
import { TEpic } from "Redux/Config";

export const deleteImageEpic: TEpic = (action$, store$, { ImageRepository }) => {
    return action$.pipe(
        ofType(DELETE_IMAGE_REQUEST),
        mergeMap(action => from(ImageRepository.remove( action.payload.id ))
            .pipe(
                mergeMap(() => {
                    return from([
                        showSuccessNotification(`Das Bild wurde erfolgreich gelöscht.`),
                        deleteImageSuccess(action.payload.id),
                    ]);
                }),
                catchError( error => {
                    return from([
                        deleteImageFailure(error),
                    ])
                })
            )
        ),
    );
}
